export const mockEditions = [
  {
    id: 'ed1',
    number: 14820,
    date: '2026-04-07',
    theme: 'Eleições Municipais 2026',
    status: 'em_producao',
    pages: 24,
    articles: 18,
    ads: 12,
    words: 14200,
    coverImage: 'https://public.readdy.ai/ai/img_res/1ddad1492a01d0443682e92b5f897566.jpg',
  },
  {
    id: 'ed2',
    number: 14819,
    date: '2026-04-06',
    theme: 'Economia Regional',
    status: 'publicado',
    pages: 20,
    articles: 15,
    ads: 10,
    words: 11800,
    coverImage: 'https://readdy.ai/api/search-image?query=newspaper%20economy%20business%20financial%20news%20editorial%20print%20layout%20professional&width=400&height=560&seq=ed2&orientation=portrait',
  },
  {
    id: 'ed3',
    number: 14818,
    date: '2026-04-05',
    theme: 'Festival de Cinema',
    status: 'publicado',
    pages: 28,
    articles: 22,
    ads: 14,
    words: 16500,
    coverImage: 'https://readdy.ai/api/search-image?query=newspaper%20culture%20arts%20cinema%20festival%20editorial%20layout%20print%20design&width=400&height=560&seq=ed3&orientation=portrait',
  },
  {
    id: 'ed4',
    number: 14821,
    date: '2026-04-08',
    theme: 'Esportes e Saúde',
    status: 'planejado',
    pages: 0,
    articles: 0,
    ads: 0,
    words: 0,
    coverImage: 'https://readdy.ai/api/search-image?query=newspaper%20sports%20health%20wellness%20editorial%20layout%20print%20design%20planning&width=400&height=560&seq=ed4&orientation=portrait',
  },
];

export const mockLayoutPages = [
  { id: 'p1', editionId: 'ed1', number: 1, type: 'capa', status: 'aprovado', articles: 3 },
  { id: 'p2', editionId: 'ed1', number: 2, type: 'política', status: 'aprovado', articles: 4 },
  { id: 'p3', editionId: 'ed1', number: 3, type: 'política', status: 'revisão', articles: 3 },
  { id: 'p4', editionId: 'ed1', number: 4, type: 'economia', status: 'rascunho', articles: 2 },
  { id: 'p5', editionId: 'ed1', number: 5, type: 'esportes', status: 'rascunho', articles: 4 },
  { id: 'p6', editionId: 'ed1', number: 6, type: 'cultura', status: 'rascunho', articles: 3 },
];
